var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-group',_vm._b({},'form-group',Object.assign({}, _vm.$attrs, _vm.$props),false),[_c('b-form-input',{ref:"input",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }